import { Injectable } from '@angular/core';
import { AppState } from '@app/store';
import { select, Store } from '@ngrx/store';
import {
  setMinimalBcs,
  setWeightManagementFollowUpAction,
  setWeightManagementFormValues,
} from './store/actions/weight-management-patient.actions';
import { FollowUpAction, PetInfo } from '@app/core/models';
import {
  getFollowUpProductsAndSetNextStep,
  getWeightManagementRecommendation,
} from './store/actions/weight-management-recommendation.actions';
import {
  navigateBackToStep,
  resetWeightManagementState,
  setWeightManagementStep,
  startWeightManagement,
} from './store/actions/weight-management-steps.actions';
import { WeightManagementStep } from './weight-management-step';
import { PanelSectionTypeEnum } from '@app/shared/utils';
import { selectFollowUpAction, selectMinimalBcs } from './store/selectors/weight-management-patient.selectors';
import { Observable } from 'rxjs';
import { selectSteps, selectStep, selectWeightManagementPetSummary } from './store/selectors/weight-management-steps.selectors';

@Injectable()
export class WeightManagementFacade {
  /** weight-management-patient.selectors */
  public followUpAction$: Observable<FollowUpAction> = this.store$.pipe(select(selectFollowUpAction));
  public minimalBcs$: Observable<number> = this.store$.pipe(select(selectMinimalBcs));

  /** weight-management-steps.selectors */
  public steps$: Observable<WeightManagementStep[]> = this.store$.pipe(select(selectSteps));
  public step$: Observable<WeightManagementStep> = this.store$.pipe(select(selectStep));
  public weightManagementPetSummary$: Observable<PetInfo> = this.store$.pipe(select(selectWeightManagementPetSummary));

  constructor(private readonly store$: Store<AppState>) {}

  /** weight-management-patient.actions */
  setWeightManagementFormValues(): void {
    this.store$.dispatch(setWeightManagementFormValues());
  }

  setWeightManagementFollowUpAction(action: FollowUpAction): void {
    this.store$.dispatch(setWeightManagementFollowUpAction({ value: action }));
  }

  setMinimalBcs(bcs: number): void {
    this.store$.dispatch(setMinimalBcs({ value: bcs }));
  }

  /** weight-management-recommendation.actions */
  getWeightManagementRecommendation(): void {
    this.store$.dispatch(getWeightManagementRecommendation());
  }

  getFollowUpProductsAndSetNextStep(): void {
    this.store$.dispatch(getFollowUpProductsAndSetNextStep());
  }

  /** weight-management-steps.actions */
  startWeightManagement(step?: WeightManagementStep): void {
    this.store$.dispatch(startWeightManagement({ step }));
  }

  setWeightManagementStep(step: WeightManagementStep): void {
    this.store$.dispatch(setWeightManagementStep({ value: step }));
  }

  navigateBackToStep(value: PanelSectionTypeEnum): void {
    this.store$.dispatch(navigateBackToStep({ value }));
  }

  resetWeightManagementState(): void {
    this.store$.dispatch(resetWeightManagementState());
  }
}
